module.exports = __webpack_public_path__ + "img/noti5.a345739d.jpg";